module.exports = __webpack_public_path__ + "static/4-b68b53155889857b0f67cc1a568678da.jpg";